import {openPanelInModal} from '@Components/modal-container/modal-container-reducer';
import {MODALS_IDS} from '@Components/modal-container';
import {triggerResumablePanelOpening} from '@Components/modal/modal.library';
import type {DownloadPanelProps} from '@Components/download-panel/download-panel';
import {GA4EventName, GA4EventParamName, trackPosterBuilderGA4Events} from '@Libraries/ga-events';
import {setCurrentViewingOrderIdKey, setIsViewingDropboxDownloads} from '@Components/download-panel/download-panel.reducer';

export interface DownloadModalProps extends DownloadPanelProps {
  modalClassName?: string;
}

export const DOWNLOAD_MODAL_PANEL_ID = 'download-panel-wrapper';

export const openNewDownloadModal = (props: DownloadModalProps): void => {
  const panelProps = {
    ...props,
    id: DOWNLOAD_MODAL_PANEL_ID,
    isOpenedInModal: true,
    hideOnClose: true,
  };

  let sourceForEvent = 'editor';
  if (props.isOpenedInPrintShop) {
    sourceForEvent = 'print-shop';
  } else {
    if (!props.isOpenedInEditor) {
      sourceForEvent = 'mystuff';
    }
  }

  trackPosterBuilderGA4Events(GA4EventName.NEW_DOWNLOAD_DIALOG_OPEN, {[GA4EventParamName.SOURCE]: sourceForEvent});
  triggerResumablePanelOpening(DOWNLOAD_MODAL_PANEL_ID);

  window.PMW.redux.store.dispatch(
    openPanelInModal({
      modalId: MODALS_IDS.DOWNLOAD_MODAL,
      panelProps: panelProps,
    })
  );

  window.PMW.redux.store.dispatch(setCurrentViewingOrderIdKey(undefined));
  window.PMW.redux.store.dispatch(setIsViewingDropboxDownloads(false));
};
